/**
 *
 * Note that this does not return the `fieldId` in the props. That is up to the component
 * to apply to the `Label` itself. Some components purposely do not set a `for` attribute
 * on their labels. These are typically components with multiple inputs wrapped in a
 * `fieldset` like `ChoiceList`, `MultiInputDateField`, and `MonthPicker`.
 */
export function useLabelProps(props) {
  var _props$labelId;
  var labelId = (_props$labelId = props.labelId) !== null && _props$labelId !== void 0 ? _props$labelId : "".concat(props.id, "__label");
  var label = props.label,
    labelClassName = props.labelClassName,
    inversed = props.inversed;
  return {
    children: label,
    className: labelClassName,
    id: labelId,
    inversed: inversed
  };
}
export default useLabelProps;